// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"UFNbB"};